import React, { useContext } from "react"
import { Divider, DividerProps } from '@/index'
import { StepsContext } from '../context'


interface StepsConnectorProps extends DividerProps {}


const Component = React.forwardRef((props: StepsConnectorProps, ref: React.Ref<any>) => {
  const { orientation } = useContext(StepsContext)

  return (
    <Divider ref={ref} orientation={orientation as any} { ...props } />
  )
})


export {
  Component as StepsConnector,
  type StepsConnectorProps,
}